import React from 'react';

import FormAutocomplete from 'components/FormAutocomplete';
import coworkerResultComponent from 'services/autocompleteServices/coworkerResultComponent/coworkerResultComponent';

type Option = { key: number; fullName: string };
type Props = {
  id: string;
  organizationId: number;
  dpiaId: number;
  membershipId: number;
  name: string;
  label: string;
  error?: string;
  disabled: boolean;
  onChange: (membershipId: number, name: string) => void;
};

export const parseResponsibleOptions = (data: unknown): Option[] => {
  if (!data || typeof data !== 'object') return [];
  const { results } = data as Record<string, unknown>;
  if (!Array.isArray(results)) return [];
  return results.filter((value: unknown): value is Option => {
    if (!value || typeof value !== 'object') return false;
    const item = value as Record<string, unknown>;
    return typeof item.key === 'number' && item.key > 0 && typeof item.fullName === 'string';
  });
};

const DpiaMeasurePersonPicker: React.FC<Props> = ({ id, organizationId, dpiaId, membershipId, name, label, error, disabled, onChange }) => (
  <FormAutocomplete
    apiCallParamsGetter={(search: string) => ({
      url: `/api/v1/organizations/${organizationId}/dpias/${dpiaId}/responsible-options/?search=${encodeURIComponent(search)}`,
      method: 'GET',
    })}
    customizeLabel={coworkerResultComponent}
    disabled={disabled}
    formik={{
      values: { [id]: membershipId ? [{ key: membershipId, fullName: name }] : [] },
      touched: { [id]: Boolean(error) },
      errors: { [id]: error },
      setFieldValue: (_field: string, options: Option[]) => onChange(options[0]?.key ?? 0, options[0]?.fullName ?? ''),
    }}
    id={id}
    label={label}
    multiple={false}
    optionsParser={parseResponsibleOptions}
  />
);

export default DpiaMeasurePersonPicker;
